import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CrmIntegration } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';

type GetCrmIntegrationsQueryParams = {
  organizationId?: string;
};

export type GetCrmIntegrationsParams = GetCollectionQueryParams<CrmIntegration> & {
  filters?: GetCrmIntegrationsQueryParams;
};

export const getCrmIntegrations = async (
  params: GetCrmIntegrationsParams
): Promise<ApiCollectionResponse<CrmIntegration>> => {
  return await tinctApi.crmIntegrations.getCrmIntegrations(params);
};

export const useGetCrmIntegrations = (
  params: GetCrmIntegrationsParams,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<CrmIntegration>, ApiError>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery({
    queryKey: ['crm-integrations', params],
    queryFn: () => getCrmIntegrations(params),
    ...options,
  });
